import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { FeaturedDownloads } from '../components/featured/FeaturedDownloads';
import { getDirectUrl, getMediaUrl } from '../utils/mediaUtils';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FeaturedVideo() {
  const { slug } = useParams();
  const [video, setVideo] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setVideo(null);
    axios.get(`${API}/featured-videos/${slug}`).then(({ data }) => setVideo(data)).catch(() => setError(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-background-primary">
      <Navbar />
      {error && <p className="text-center py-32 font-body text-slate-600" data-testid="featured-video-not-found">Video not found.</p>}
      {!video && !error && <p className="text-center py-32 font-body text-slate-600">Loading...</p>}
      {video && (
        <>
          <SEO title={`${video.title} | RestoreMyWord.net`} description={video.description || video.title} url={`https://restoremyword.net/videos/featured/${video.slug}`} image={video.cover_url} />
          <section className="bg-brand-primary py-10 md:py-14" data-testid="featured-video-page">
            <div className="max-w-5xl mx-auto px-4 sm:px-6 md:px-12">
              <Link to="/videos" className="inline-flex items-center gap-2 text-sm font-body text-white/70 hover:text-brand-accent mb-6 transition-colors duration-300" data-testid="featured-video-back-link">
                <ArrowLeft className="h-4 w-4" /> Back to Videos
              </Link>
              <div className="bg-black rounded overflow-hidden shadow-2xl">
                <video
                  controls
                  playsInline
                  preload="metadata"
                  poster={getDirectUrl(video.cover_url)}
                  src={getMediaUrl(video.video_url)}
                  className="w-full aspect-video bg-black"
                  data-testid="featured-video-player"
                />
              </div>
            </div>
          </section>
          <section className="py-10 md:py-14">
            <div className="max-w-5xl mx-auto px-4 sm:px-6 md:px-12">
              <h1 className="font-heading text-3xl md:text-4xl font-semibold text-brand-primary leading-tight mb-4" data-testid="featured-video-page-title">{video.title}</h1>
              {video.description && <p className="font-body text-base md:text-lg text-slate-700 leading-relaxed mb-8">{video.description}</p>}
              <FeaturedDownloads video={video} />
            </div>
          </section>
        </>
      )}
      <Footer />
    </div>
  );
}
